import { userInfo } from '@/network/api'

const state = {
    isLogin: false,
    user_info: {
        headimgurl: '',
        nickname: '',
        memberLevel: ''
    }
}

const mutations = {
    SET_LOGIN: (state, isLogin) => {
        state.isLogin = isLogin
    },
    SET_INFO: (state, user_info) => {
        state.user_info = user_info
    },
}

const actions = {
    changeLoginStatus({ commit }, isLogin) {
        console.log(isLogin)
        commit('SET_LOGIN', isLogin)
    },
    // get user info
    getInfo({ commit, state }) {
        return new Promise((resolve, reject) => {
            userInfo().then(res => {
                if (res.data.phone) {
                    commit('SET_LOGIN', true)
                } else {
                    commit('SET_LOGIN', false)
                }
                commit('SET_INFO', res.data)
                resolve(res.data)
            }).catch(error => {
                window.localStorage.removeItem('token')
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js